export const environment = {
  apiUrl: 'https://endkundenrechner-api.cpit.dev',
  enableTestDataViewer: false,
  allowBrandingQueryParam: false,
};
